import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/back.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  "sticky-container": "",
  class: "sticky-container"
}
const _hoisted_3 = {
  key: 0,
  class: "sticky",
  "sticky-offset": "{top: 0}",
  "sticky-side": "both",
  "on-stick": "onStick",
  "sticky-z-index": "20"
}
const _hoisted_4 = { class: "flexBox" }
const _hoisted_5 = {
  key: 0,
  class: "header-box header-component-m"
}
const _hoisted_6 = {
  key: 1,
  class: "header-box header-component"
}
const _hoisted_7 = { class: "app-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileHeader = _resolveComponent("MobileHeader")!
  const _component_CCHeader = _resolveComponent("CCHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_sticky = _resolveDirective("sticky")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.initNextTick && _ctx.$route.name !== 'lavandula-vip')
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              ($setup.CheckMobileDevice())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_MobileHeader, {
                      onClickMenu: $setup.OnClickMenu,
                      onClickChildMenu: $setup.OnClickChildMenu
                    }, null, 8, ["onClickMenu", "onClickChildMenu"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_CCHeader, {
                      onClickMenu: $setup.OnClickMenu,
                      onClickChildMenu: $setup.OnClickChildMenu
                    }, null, 8, ["onClickMenu", "onClickChildMenu"])
                  ]))
            ])
          ])), [
            [_directive_sticky, true]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ]),
      (_ctx.$route.name !== 'lavandula-vip')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['scrollTop', $setup.scrollState ? 'show' : '', $setup.CheckMobileDevice() ? 'mobile_back' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clickScrollTop()))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}